<app-header></app-header>

<section class="bg-half-170 d-table w-100" id="home" style="background: url('assets/images/travel/bg.jpg') center center;">
    <div class="bg-overlay"></div>
    <div class="container">
        <!-- <div class="col-lg-12 text-center">
          <div class="pages-heading">
            <h3 class="title text-white title-dark mb-0"> {{modelObject.titleEn}} </h3>
          </div>
        </div> -->
        <!--end col-->
  
      <div class="position-breadcrumb">
        <nav aria-label="breadcrumb" class="d-inline-block">
          <ul class="breadcrumb rounded shadow mb-0 px-4 py-2">
                  <li class="breadcrumb-item"><a routerLink="">Blimp</a></li>
                  <li class="breadcrumb-item"><a routerLink="/adventures">Adventures</a></li>
                  <li class="breadcrumb-item"><a routerLink="/events-world">Adventure Details</a></li>
          </ul>
        </nav>
      </div>
    </div> <!--end container-->
  </section><!--end section-->
  
  <div class="position-relative">
    <div class="shape overflow-hidden text-color-white">
      <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
      </svg>
    </div>
  </div>
  <!-- Hero End -->
<section class="section">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-10 mt-4 pt-2">
            <ngb-carousel id="customer-testi" [options]="customOptions">
                <ng-template ngbSlide *ngFor="let item of files">
                  <div class="tiny-slide">                                
                     <img src="{{item.imageURL}}" class="d-block w-100" alt="...">
                  </div>
                </ng-template>
              </ngb-carousel>
          <!-- <img src="assets/images/work/single.jpg" class="img-fluid rounded" alt=""> -->
        </div>
  
        <div class="col-md-10 mt-4 pt-2">
          <div class="bg-light rounded p-4">
            <p class="text-muted mb-0" style="font-weight: bold;">"{{modelObject.descriptionEn}}. "</p>
          </div>
  
         
  
          <div class="row align-items-center">
            <div class="col-lg-6 mt-4 pt-2">
              <div class="card work-details rounded bg-light border-0">
                <div class="card-body">
                  <h5 class="card-title border-bottom pb-3 mb-3">Adventure Info</h5>
                  <dl class="row mb-0">
                    <dt class="col-md-5 col-5">Title :</dt>
                    <dd class="col-md-7 col-7 text-muted">{{modelObject.titleEn}}</dd>
  
                    <dt class="col-md-5 col-5">Number of Days :</dt>
                    <dd class="col-md-7 col-7 text-muted">{{modelObject.numberOfDays}} Day Tour</dd>
  
                    <dt class="col-md-5 col-5">Date :</dt>
                    <dd class="col-md-7 col-7 text-muted">{{modelObject.date |date:'dd/MM/yyyy hh:MM'}}</dd>
  
                    <dt class="col-md-5 col-5">Country :</dt>
                    <dd class="col-md-7 col-7 text-muted">{{modelObject.countryNameEn}}</dd>
  
                    <dt class="col-md-5 col-5">City :</dt>
                    <dd class="col-md-7 col-7 text-muted">{{modelObject.cityNameEn}}</dd>
                  </dl>
                </div>
              </div>
            </div>
    
           
            <div class="col-lg-6 mt-4 pt-2">
                <ngb-carousel id="customer-testi" [options]="customOptions">
                    <ng-template ngbSlide *ngFor="let item of files">
                      <div class="tiny-slide">                                
                         <img src="{{item.imageURL}}" class="d-block w-100" alt="...">
                      </div>
                    </ng-template>
                  </ngb-carousel>
            </div>
          </div>
          <div class="row align-items-center">
            <div class="col-lg-12 mt-4 pt-2">
                <div class="card-body">
                <h5 class="card-title border-bottom pb-3 mb-3">Adventure Itinerary</h5>
                <ngb-accordion #acc="ngbAccordion" activeIds="ngb-panel-0" closeOthers="true" *ngFor="let item of itineraryList">
                    <ngb-panel  cardClass="border-0 rounded shadow mb-2" >
                      <ng-template ngbPanelTitle>
                        <div class="border-0 bg-light" id="headingone">
                          <h6 class="title mb-0">{{item.itineraryNameEn}} </h6>
                        </div>
                      </ng-template>
                      <ng-template ngbPanelContent>
                        <p class="text-muted mb-0 faq-ans">{{item.descriptionEn}}.</p>
                      </ng-template>
                    </ngb-panel>
                  </ngb-accordion>
                </div>
            </div>
        </div>
        
          <div class="row align-items-center">
            <div class="col-lg-12 mt-4 pt-2">
              <div class="card work-details rounded bg-light border-0">
                <div class="card-body">
                  <h5 class="card-title border-bottom pb-3 mb-3">Adventure Included</h5>
                  <dl class="row mb-0" *ngFor="let included of includedList">
                    <dt class="col-md-5 col-5">{{included.includedNameEn}} </dt>
                    <dd class="col-md-7 col-7 text-muted">{{included.descriptionEn}}</dd>
                  </dl>
                </div>
              </div>
            </div>
          </div>
          <!-- Comment Areas start -->
          <div class="card shadow rounded border-0 mt-4">
            <div class="card-body">
              <h5 class="card-title mb-0">Comments :</h5>
             </div>
             <owl-carousel-o id="customer-testi" [options]="customOptions2">
                <ng-container *ngFor="let data of EvaluationAdventuresList">
                    <ng-template carouselSlide>
                        <div class="tiny-slide">
                            <div class="d-flex client-testi m-1">
                                <img src="assets/images/client/01.jpg" class="avatar avatar-small client-image rounded shadow" alt="">
                                <div class="card flex-1 content p-3 shadow rounded position-relative">
                                    <ul class="list-unstyled mb-0">
                                    <ngb-rating [max]="5" [(rate)]="data.numberOfStars" [readonly]="true" style="font-size: 30px;"> </ngb-rating>
                                    </ul>
                                    <p class="text-muted mt-2">{{data.comment}}</p>
                                    <h6 class="text-primary">- Mohamed <small class="text-muted">{{data.date|date:'dd/MM/yyyy hh:MM'}}</small>
                                  
                                      <a  href="javascript:void(0)" data-bs-toggle="modal" (click)="setCommentId(data.id)" data-bs-target="#LoginForm" class="btn btn-primary ms-md-4" style="width: 77px; height: 30px; font-size: 10px;"> Report</a>
                                    </h6>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </ng-container>
            </owl-carousel-o>
          </div>
  
          <!-- Comments -->
          <div class="card shadow rounded border-0 mt-4">
            <div class="card-body">
              <h5 class="card-title mb-0">Leave A Comment :</h5>
  
              <form class="mt-3">
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group position-relative">
                      <label>Your Comment</label>
                      <div class="form-icon position-relative">
                        <i-feather name="message-circle" class="fea icon-sm icons"></i-feather>
                        <textarea id="message" placeholder="Your Comment" rows="5" name="message"
                          class="form-control ps-5" required="" [(ngModel)]="myComment"></textarea>
                      </div>
                      <div >
                        <ngb-rating  [max]="5" [(rate)]="myStars" [readonly]="false"></ngb-rating>
                      </div>
                    </div>
                  </div>
  
                  <div class="col-md-12">
                    <div class="send">
                      <button type="submit" class="btn btn-primary btn-block" (click)="Save()">Comment</button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <div *ngIf="ReportForm" class="modal fade" id="LoginForm" tabindex="-1" aria-labelledby="LoginForm-title" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content rounded shadow border-0">
            <div class="modal-header border-bottom">
                <h5 class="modal-title" id="LoginForm-title">Send Report</h5>
                <button type="button" class="btn btn-icon btn-close" data-bs-dismiss="modal" id="close-modal"><i class="uil uil-times fs-4 text-dark"></i></button>
            </div>
            <div class="modal-body">
              <h3 class="modal-title" id="LoginForm-title">Your Report</h3>
                <div class="bg-white p-3 rounded box-shadow">
                  <div class="row">
                    <textarea class="text-muted mb-0" rows="6" [(ngModel)]="message"> </textarea>                                                        
                  </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" #closebutton id="closebutton">Close</button>
                <button type="button" class="btn btn-primary" (click)="SendReport()">Send</button>
            </div>
        </div>
    </div>
    <ngb-alert>
      <strong>Well done!</strong> You successfully read this important alert message.
    </ngb-alert>
</div>
<a href="javascript: void(0);" class="btn btn-icon btn-primary back-to-top" id="back-to-top" [ngxScrollTo]="'#home'">
  <i-feather name="arrow-up" class="icons"></i-feather>
</a>